// extracted by mini-css-extract-plugin
module.exports = {"slideContainer":"_2m6AL"};